import React from 'react'

export function listFilm() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" style={{enableBackground: "new 0 0 16 16"}} xmlSpace="preserve">
      <path className="fill" fillRule="nonzero" d="M13.6 0H2.4C1.12 0 0 1.04 0 2.4v11.2C0 14.96 1.04 16 2.4 16h11.2c1.36 0 2.4-1.04 2.4-2.4V2.4C16 1.04 14.96 0 13.6 0zm-.8 5.2h1.6v2h-1.6v-2zm-1.6 2H4.8V1.6h6.4v5.6zm-8 0H1.6v-2h1.6v2zM1.6 8.8h1.6v2H1.6v-2zm3.2 0h6.4v5.6H4.8V8.8zm8 0h1.6v2h-1.6v-2zm1.6-6.4v1.2h-1.6v-2h.8c.48 0 .8.32.8.8zm-12-.8h.8v2H1.6V2.4c0-.48.4-.8.8-.8zm-.8 12v-1.2h1.6v2h-.8c-.4 0-.8-.32-.8-.8zm12 .8h-.8v-2h1.6v1.2c0 .48-.32.8-.8.8z"/>
    </svg>
  )
}
